import React from "react";
import classNames from "classnames";
import constants from "../../../../../globalization";
import classes from "./Notifications.module.css";

const ButtonsContent = (props) => {
  const {
    ack,
    dismiss,
    goAndDismiss,
    notificationGoAndDismiss,
    dismissNotification,
    ackNotification,
    acknowledgeIdCheck,
    // acknowledgeOverServe,
    notification,
    showGoAndDismiss,
    goToCheck,
    managerMode,
  } = props || {};

  // if (notification.notificationTypeId === 14) {
  //   return (
  //     <div className={classes.buttonsContainer}>
  //       <button
  //         type="submit"
  //         className={classes.button}
  //         onClick={() => goToCheck(notification)}
  //       >
  //         <span className={classes.buttonText}>
  //           {constants.goToCheck}
  //         </span>
  //       </button>

  //       {!managerMode && notification.notificationTypeId === 14 ? (
  //         <button
  //           type="submit"
  //           className={classes.button}
  //           onClick={() => dismissNotification(notification)}
  //         >
  //           <span className={classes.buttonText}>{constants.notificationDismiss}</span>
  //         </button>) : null}
  //     </div>
  //   );
  // }

  return (
    <div className={classes.buttonsContainer}>
      {!showGoAndDismiss(notification) ? null : (
        <button
          type="submit"
          className={classes.button}
          onClick={() => notificationGoAndDismiss(notification)}
        >
          <span
            className={classNames(
              `${classes.buttonText}`,
              `${classes.goAndDismissButton}`
            )}
          >
            {constants.notificationGoAndDismiss}
          </span>
        </button>
      )}
      {dismiss ? (
        <button
          type="submit"
          className={classes.button}
          onClick={() => ackNotification(notification)}
        >
          <span className={classes.buttonText}>{constants.notificationDismiss}</span>
        </button>
      ) : null}
    </div>
  );
};

export default ButtonsContent;
